import { render } from "./toasts.vue?vue&type=template&id=615d4208&scoped=true&ts=true"
import script from "./toasts.vue?vue&type=script&lang=ts"
export * from "./toasts.vue?vue&type=script&lang=ts"

import "./toasts.vue?vue&type=style&index=0&id=615d4208&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cow-app/cow-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615d4208"]])

export default __exports__